import React from 'react'
import styled from 'styled-components'

import {
  space,
  color,
  layout,
  background,
  border,
  position,
  shadow,
  typography,
  grid,
  flex,
} from 'styled-system'
import { overrideColorConfig } from '../../utils/global'
import { PolymorphicRef } from '../Box/Box.types'
import { PolymorphGridProps, GridProps, GridComponent } from './Grid.types'
import { getGapUtils } from './utils'

const StyledGrid: React.FC<PolymorphGridProps<React.ElementType>> = styled.div<
  GridProps<React.ElementType>
>`
  display: grid;
  cursor: ${(props) => props.cursor};
  ${grid}
  ${color}
  ${layout}
  ${background}
  ${border}
  ${shadow}
  ${space}
  ${position}
  ${getGapUtils}
  ${typography}
  ${overrideColorConfig}
  ${flex}
`

const Grid: GridComponent = React.forwardRef(
  <C extends React.ElementType = 'div'>(
    { ...props }: PolymorphGridProps<C>,
    ref?: PolymorphicRef<C>,
  ) => <StyledGrid ref={ref} {...props} />,
)
export default Grid
